<ng-template #templateRef>
  <mat-horizontal-stepper #stepper [linear]="true">
    <mat-step [completed]="Sheets.length > 0" errorMessage="Fill in the required fields" label="Upload excell file">
      <div class="row">
        <div class="col-12">
          <form>
            <input (change)="readFile($event);" name="file" type="file">
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button class="float-left" mat-button matStepperPrevious>Back</button>
          <div class="fill-remaining-space"></div>
          <button class="float-right" mat-button matStepperNext>Next</button>
        </div>
      </div>
    </mat-step>
    <mat-step [completed]="!!(Sheet)" errorMessage="Fill in the required fields" label="Select Sheet">
      <div class="row">
        <div class="col-12">
          <form>
            <mat-form-field>
              <mat-label>Selected Sheet</mat-label>
              <mat-select [(ngModel)]="Sheet" (ngModelChange)="parseRows()"  name="SelectedSheet" required>
                <mat-option *ngFor="let sheet of Sheets" [value]="sheet.Worksheet">
                  {{sheet.Title}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button class="float-left" mat-button matStepperPrevious>Back</button>
          <div class="fill-remaining-space"></div>
          <button class="float-right" mat-button matStepperNext>Next</button>
        </div>
      </div>
    </mat-step>
    <mat-step [completed]="!!(DocumentNumberColumn && TrackAndTraceColumn)" errorMessage="Fill in the required fields" label="Select Columns">
      <div class="row">
        <div class="col-4">
          <form>
            <mat-form-field>
              <mat-label>Document number column</mat-label>
              <mat-select [(ngModel)]="DocumentNumberColumn" (ngModelChange)="getDocuments()"  [disabled]="!Sheet || !Columns || (Columns && Columns.length === 0)" name="DocumentNumberColumn"
                          required>
                <mat-option *ngFor="let row of Columns; let i = index;" [value]="i">
                  {{row}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
        <div class="col-4">
          <mat-form-field>
            <mat-label>Tracking code prefix</mat-label>
            <input [(ngModel)]="TrackingCodePrefix" matInput name="TrackingCodePrefix">
            <mat-hint>Is the url complete or do you need to add a url?</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-4">
          <form>
            <mat-form-field>
              <mat-label>Track and Trace column</mat-label>
              <mat-select [(ngModel)]="TrackAndTraceColumn" [disabled]="!Sheet || !Columns || (Columns && Columns.length === 0)" name="TrackAndTraceColumn"
                          required>
                <mat-option *ngFor="let row of Columns; let i = index;" [value]="i">
                  {{row}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button class="float-left" mat-button matStepperPrevious>Back</button>
          <div class="fill-remaining-space"></div>
          <button class="float-right" mat-button matStepperNext>Next</button>
        </div>
      </div>
    </mat-step>
    <mat-step errorMessage="Fill in the required fields" label="Validate">
      <div class="row">
        <div class="col-12">
          <table class="mat-mdc-table">
            <tr>
              <th>Row</th>
              <th>Document Number</th>
              <th>Document Found</th>
              <th>Track And Trace Number</th>
              <th>Updated</th>
            </tr>
            <ng-container *ngFor="let row of Rows; let i = index">
              <tr>
                <td>
                  {{i + 1}}
                </td>
                <td>
                  {{row[DocumentNumberColumn]}}
                </td>
                <td>
                  <mat-icon *ngIf="!filterObject.loading">{{!documentFound(row[DocumentNumberColumn]) ? 'clear' : 'check'}}</mat-icon>
                  <mat-spinner *ngIf="filterObject.loading" class="spinner"
                               color="accent" diameter="18"></mat-spinner>
                </td>
                <td>
                  {{row[TrackAndTraceColumn]}}
                </td>
                <td>
                  <mat-icon *ngIf="!LoadingList[i]">{{CompletedList[i] ? 'check' : 'clear'}}</mat-icon>
                  <mat-spinner *ngIf="LoadingList[i]" class="spinner"
                               color="accent" diameter="18"></mat-spinner>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button class="float-left" mat-button matStepperPrevious>Back</button>
          <div class="fill-remaining-space"></div>
          <button class="float-right" (click)="import()" [disabled]="filterObject.loading || LoadingDocumentsList.indexOf(true) > -1" color="primary" mat-button mat-raised-button>Import</button>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
  <app-email-editor #emailEditor></app-email-editor>
</ng-template>
